// src/components/layout/NavigationTabs.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled components con Material UI
const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: '1px solid #e0e0e0',
  minHeight: '48px',
  '& .MuiTabs-indicator': {
    backgroundColor: '#f59e0b', // Color naranja como en la imagen
    height: '3px',
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 100,
  fontWeight: 500,
  fontSize: '0.95rem',
  color: '#6b7280',
  padding: '12px 24px',
  '&:hover': {
    color: '#f59e0b',
    backgroundColor: 'rgba(245, 158, 11, 0.04)',
  },
  '&.Mui-selected': {
    color: '#f59e0b',
    fontWeight: 600,
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'rgba(245, 158, 11, 0.08)',
  },
}));

/**
 * Componente de navegación entre las diferentes áreas del dashboard
 * @param {Object} props
 * @param {string} props.currentTab - Tab activo actual (opcional, se detecta automáticamente por la ruta)
 */
const NavigationTabs = ({ currentTab }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Mapeo de rutas a índices de tabs
  const routeToTabIndex = {
    '/cultura/group-operational': 0,
    '/agicab/group-operational': 1,
    '/odoo/group-operational': 2,
    '/global/group-operational': 3,
  };

  // Detectar tab activo basado en la ruta actual
  const getCurrentTabIndex = () => {
    if (currentTab !== undefined) {
      return currentTab;
    }
    
    // Buscar coincidencia exacta
    if (routeToTabIndex[location.pathname] !== undefined) {
      return routeToTabIndex[location.pathname];
    }
    
    // Buscar coincidencia parcial (para sub-rutas)
    for (const [route, index] of Object.entries(routeToTabIndex)) {
      if (location.pathname.startsWith(route)) {
        return index;
      }
    }
    
    return 3; // Default: Management Culture
  };

  const handleTabChange = (event, newValue) => {
    const routes = ['', '', '', '/global/group-operational'];
    navigate(routes[newValue]);
  };

  return (
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <StyledTabs
        value={getCurrentTabIndex()}
        onChange={handleTabChange}
        aria-label="Navigation tabs"
        variant="standard"
      >
        <StyledTab label="Cultura" />
        <StyledTab label="Agicab" />
        <StyledTab label="Odoo" />
        <StyledTab label="Global" />
      </StyledTabs>
    </Box>
  );
};

export default NavigationTabs;